export let URL_TYPES = /*#__PURE__*/function (URL_TYPES) {
  URL_TYPES["VIDEO"] = "video";
  URL_TYPES["CHANNEL"] = "channel";
  URL_TYPES["USER_NAME"] = "username";
  URL_TYPES["PLAYLIST"] = "playlist";
  return URL_TYPES;
}({});
//# sourceMappingURL=url-types.js.map